<template>
  <div class="w-full">
    <IftaLabel v-if="!isButton" class="w-full">
      <InputText :id="id" :type="type" v-model="inputValue" />
      <label :for="id">{{ title }}</label>
    </IftaLabel>
    <InputGroup v-else>
      <IftaLabel class="w-full">
        <InputText :id="id" :type="type" v-model="inputValue" />
        <label :for="id">{{ title }}</label>
      </IftaLabel>
      <Button
        v-if="isButton"
        :icon="buttonIcon"
        @click="emit('button-click')"
      ></Button>
    </InputGroup>
    <span v-if="tooltipText" class="text-sm text-gray-500 mt-1">
      {{ tooltipText }}
    </span>
  </div>
</template>

<script setup lang="ts">
  import { defineEmits, defineProps, ref, watch } from 'vue';
  import { useNotification } from '@kyvg/vue3-notification';

  const { notify } = useNotification();
  const props = defineProps<{
    modelValue: number | string;
    title: string;
    id: string;
    type: string;
    tooltipText?: string | null;
    validation?: any;
    validationText?: string;
    isButton?: boolean;
    buttonIcon?: string;
  }>();

  const emit = defineEmits(['update:modelValue', 'button-click']);

  const inputValue = ref<number | string>(props.modelValue);

  watch(inputValue, (newValue, oldValue) => {
    if (typeof props.validation === 'function') {
      if (!props.validation(newValue)) {
        inputValue.value = oldValue;
        notify({
          type: 'error',
          title: 'Validation',
          text: props.validationText,
        });
        return;
      }
    }
    emit('update:modelValue', newValue);
  });

  watch(
    () => props.modelValue,
    (newValue) => {
      inputValue.value = newValue;
    }
  );
</script>
